// Non usare i trattini perchè causano errori
export const ORDERS_DESCRIBE: string = 'orders';
